import styled from 'styled-components';

import Button from '@components/Button';

export const StyledButton = styled(Button)`
  border: 0px;
  height: 56px !important;
  width: 100% !important;
`;

export const SearchButton = styled.button`
  font-size: 14px !important;
  font-weight: bold;
  height: 56px !important;
  border: none;
  border-radius: 4px;
`;
export const ButtonText = styled.button<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.white : theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  padding: 16px;
`;
